import { Injectable } from '@angular/core';
import { IApplicationAttributeDto } from '@common-modules/dependencies/shared/model/application-attribute.dto';
import { UserDto } from '@common-modules/shared/model/roles/user.dto';
import { Observable, of } from 'rxjs';

@Injectable()
export class TCGlobalsService {
  getCurrentUser(): Observable<UserDto> {
    const mockUser: UserDto = {
      userCode: 'ThinClient',
      surname: '',
      name: 'ThinClient',
      groupIds: [],
      isActive: true,
      isSuperUser: true,
      lastAccess: new Date(),
      getFullName: 'ThinClient',
    };
    const user$ = of(mockUser);
    return user$;
  }

  getHierarchyRelationLevels(): Observable<any[]> {
    return of([]);
  }

  getApplicationAttributesById(attributeId: number): Observable<IApplicationAttributeDto> {
    const result: IApplicationAttributeDto = {
      attributeId: 1,
      attributeName: 'Attribute',
      attributeDataTypeId: 1,
      attributeValue: '1',
    };

    return of(result);
  }
}
